module.exports = __webpack_public_path__ + "static/media/info-icon3.0b62d82b.png";